// removed by extract-text-webpack-plugin
module.exports = {"oy_tab":"oy_tab__j24GO47a","oy_tab_head":"oy_tab_head__1o5Tyqgh","oy_tab_head_item":"oy_tab_head_item__s0cxg4Ke","active":"active__4N02ADzB","oy_tab_content":"oy_tab_content__IlBdZZ5y","active_content":"active_content__3gGYjOnu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYTab/index.module.less
// module id = 751
// module chunks = 1